const PricePage = () => import('../pages/PricePage.vue');

export default [
    {
        name: 'price',
        path: '/price',
        component: PricePage,
    },
];
